import { modes, paneModes } from '@constants/orderWizard'
import { Alert } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDestinationsContext } from '../../../../Contexts/DestinationsContext'
import { useSupplyOptionContext } from '../../../../Contexts/SupplyOptionContext'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { CarrierWindowOverride } from './AlertPanes/CarrierWindowOverride'
import { NonOptimalChosen } from './AlertPanes/NonOptimalChosen'
import { UnmonitoredDeliveryWindow } from './AlertPanes/UnmonitoredDeliveryWindow'

export const EditAlertContainer = ({ canEditCarrierWindow }) => {
  const { mode, modelGenerated, paneMode, setPayload, carrierWindowState } = useWizardMaster()
  const { nonOptimalChosen } = useSupplyOptionContext()
  const { orderDestinations } = useDestinationsContext()
  const [showUnmonitoredPane, setShowUnmonitoredPane] = useState(false)
  const timezone = orderDestinations?.[0]?.timezone

  useEffect(() => {
    const hasUnmonitoredTank = orderDestinations.some(
      (dest) =>
        dest.monitoring_strategy === 'Unmonitored' ||
        dest.monitoring_strategy === 'Manual Tank Readings' ||
        dest.monitoring_strategy === 'No Readings (Call-In)'
    )
    if (!hasUnmonitoredTank) {
      setPayload((payload) => {
        const payloadCopy = { ...payload }
        delete payloadCopy.dispatch_window_override_start
        delete payloadCopy.dispatch_window_override_end
        return payloadCopy
      })
    }
    setShowUnmonitoredPane(hasUnmonitoredTank)
  }, [orderDestinations])

  const {
    isToggleDisabled,
    showCarrierWindowOverride,
    inputMode,
    setInputMode,
    isOverrideToggled,
    setIsOverrideToggled,
    customWindow,
    handleCustomWindowChange,
    handleSimpleWindowChange,
    simpleWindow,
    clearWindow,
    removeDatesFromPayload,
  } = carrierWindowState

  if (paneMode === paneModes.TANKIMPACT) {
    return (
      <>
        {showCarrierWindowOverride && (
          <CarrierWindowOverride
            canEditCarrierWindow={canEditCarrierWindow}
            inputMode={inputMode}
            setInputMode={(mode) => setInputMode(mode)}
            isOverrideToggled={isOverrideToggled}
            onOverrideToggled={(flag) => setIsOverrideToggled(flag)}
            customWindow={customWindow}
            setCustomWindow={handleCustomWindowChange}
            isInputDisabled={!isOverrideToggled}
            isToggleDisabled={isToggleDisabled}
            simpleWindow={simpleWindow}
            setSimpleWindow={handleSimpleWindowChange}
            clearWindow={clearWindow}
            removeDatesFromPayload={removeDatesFromPayload}
            timezone={timezone}
          />
        )}
        {showUnmonitoredPane && !showCarrierWindowOverride && <UnmonitoredDeliveryWindow />}
        {nonOptimalChosen && <NonOptimalChosen />}
      </>
    )
  }

  if (nonOptimalChosen) {
    return <NonOptimalChosen />
  }

  if (mode === modes.EDIT && modelGenerated()) {
    return (
      <Alert
        message='You are currently editing a model generated order. Once this is saved, it cannot be undone.'
        type='warning'
        showIcon
      />
    )
  }
  return <></>
}
